import {types} from './types'

export function fetchData(data) {
    return {
        type: types.SEND_REQUEST,
        payload: data
    }
}

export function fetchDataSuccess(data) {
    return {
        type: types.SEND_REQUEST_SUCCESS,
        payload: data
    }
}
export function fetchDataFailure(err) {
    return {
        type: types.SEND_REQUEST_FAILURE,
        payload: {},
        err: err
    }
}

